<template>
  <div class="row">
    <div class="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
      <!-- <div class="card">
        <div class="row">
          <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12">
            <h2 class="subtitle mb-1">Type</h2>
            <div class="data-block">
              <span class="content-block"
                >{{ getProductTypeFormat(product.type) }}
              </span>
            </div>
          </div>

          <div
            class="col-xl-3 col-lg-6 col-md-6 col-sm-6 offset-xl-4 text-right"
          >
            <div class="data-block">
              <div
                class="badge-status text-status status-confirmed d-inline-flex align-items-center"
                v-if="product.status === true"
              >
                <i
                  class="flaticon-bold-check-3 text-success mr-2 d-inline-flex"
                ></i>
                Active
              </div>

              <div
                class="badge-status text-status status-cancelled d-inline-flex align-items-center"
                v-else
              >
                <i
                  class="flaticon-bold-cancel text-danger mr-2 d-inline-flex"
                ></i>
                Inactive
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <h2 class="subtitle mb-1">Name | Title</h2>
        <div class="data-block">
          <span class="content-block">{{ product.name }} </span>
        </div>
      </div> -->

      <div class="card">
        <h2 class="subtitle mb-2">Parameters</h2>

        <div class="row">
          <div
            class="col-xl-3 col-lg-3 col-md-3 col-sm-5 col-12"
            v-if="product.type == 'PRIVATE_TRANSFER'"
          >
            <div class="data-block">
              <span class="title-block">Quote</span>
              <span class="content-block">{{ getQuoteFormat(quote) }} </span>
            </div>
          </div>

          <div
            class="col-xl-9 col-lg-9 col-md-9 col-sm-7 col-12"
            v-if="product.type == 'PRIVATE_TRANSFER'"
          >
            <div class="data-block">
              <span class="title-block">Type Transfer</span>
              <span class="content-block"
                >{{ getBookingType(product.transfer.type) }}
              </span>
            </div>
          </div>

          <div
            class="col-xl-2 col-lg-3 col-md-3 col-sm-3 col-12"
            v-if="product.type == 'TOUR'"
          >
            <div class="data-block">
              <span class="title-block">Quote</span>
              <span class="content-block">{{ getQuoteFormat(quote) }} </span>
            </div>
          </div>

          <div
            class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12"
            v-if="product.type == 'TOUR'"
          >
            <div class="data-block">
              <span class="title-block">Type Transfer</span>
              <span class="content-block">Hourly </span>
            </div>
          </div>

          <div
            class="col-xl-3 col-lg-4 col-md-4 col-sm-5 col-12"
            v-if="product.type == 'TOUR'"
          >
            <div class="data-block">
              <span class="title-block">Multiple Vehicles </span>
              <span class="content-block">{{
                getMultipleFormat(product.show_options)
              }}</span>
            </div>
          </div>

          <div
            class="col-xl-9 col-lg-9 col-md-9 col-sm-7 col-12"
            v-if="quote === 'AREA'"
          >
            <div class="data-block">
              <span class="title-block">Destination</span>
              <span class="content-block">{{ product.branch.name }} </span>
            </div>
          </div>

          <div
            class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
            v-if="product.from.address"
          >
            <div class="data-block">
              <span class="title-block">From</span>
              <span class="content-block">{{ product.from.address }} </span>
            </div>
          </div>

          <div
            class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
            v-if="product.to.address"
          >
            <div class="data-block">
              <span class="title-block">To</span>
              <span class="content-block">{{ product.to.address }} </span>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12"
            v-if="product.type == 'TOUR'"
          >
            <div class="data-block">
              <span class="title-block">Hours</span>
              <span class="content-block"
                >{{ product.duration.value }} Hours</span
              >
            </div>
          </div>

          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
            <div class="data-block">
              <span class="title-block">Vehicle Type</span>
              <span class="content-block"
                >{{ product.service.vehicle.name }}
              </span>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
            <div class="data-block">
              <span class="title-block">Area</span>
              <span class="content-block">{{ product.area.name }} </span>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6">
            <div class="data-block">
              <span class="title-block">N° Passengers</span>
              <span class="content-block"
                >{{ product.passengers.maximum }}
              </span>
            </div>
          </div>

          <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6">
            <div class="data-block">
              <span class="title-block">N° Bags</span>
              <span class="content-block">{{ product.bags.maximum }} </span>
            </div>
          </div>
        </div>
      </div>

      <div class="card pt-4 ">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <div class="data-block">
              <span class="title-block">Availability</span>
              <span class="content-block"
                >{{ getAvailabilityTypeFormat(product.availability.type) }}
              </span>
            </div>
          </div>

          <div
            v-if="
              product.availability.type === 'BLACKOUT' ||
                (product.availability.type === 'DEFAULT' &&
                  product.availability.value.length > 0)
            "
            class="col-12"
          >
            <div class="px-2">
              <div class="data-block mb-1">
                <span class="title-block">Blackout Dates</span>
              </div>

              <b-table
                hover
                :items="product.availability.value"
                :fields="fields"
                responsive
                selectable
                sort-icon-left
                show-empty
                empty-filtered-text="There are no records matching your request"
                empty-text="There are no records to show"
              >
                <template #cell(name)="data">
                  <span>{{ data.item.name }}</span>
                </template>
                <template #cell(from)="data">
                  <span>{{
                    getDateFormat(data.item.from, "DD-MMM-YYYY")
                  }}</span>
                </template>

                <template #cell(end)="data">
                  <span>{{ getDateFormat(data.item.end, "DD-MMM-YYYY") }}</span>
                </template>
                <template #cell(status)="data">
                  <div
                    class="badge-status badge-success"
                    v-if="data.item.status"
                  >
                    <span>Active </span>
                  </div>

                  <div class="badge-status badge-danger" v-else>
                    <span>Inactive</span>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>

      <div
        class="card pt-4"
        :class="{ 'pb-4': product.cutoff.type === 'UNRESTRICRED' }"
      >
        <div class="row">
          <div class="col-xl-3 col-lg-5 col-md-6 col-sm-7 col-12">
            <div class="data-block">
              <span class="title-block">CutOff</span>
              <span class="content-block"
                >{{ getCutOffTypeFormat(product.cutoff.type) }}
              </span>
            </div>
          </div>

          <div
            v-if="
              product.cutoff.type === 'MINIMUM' ||
                product.cutoff.type === 'DEFAULT'
            "
            class="col-xl-3 col-lg-3 col-md-4 col-sm-5 col-12"
          >
            <div class="data-block">
              <span class="title-block">Minimum CutOff</span>
              <span class="content-block"
                >{{ product.cutoff.value }} Hours
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="card pb-4">
        <h2 class="subtitle mb-3">Description</h2>
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="data-block">
              <span class="title-block">Short Description</span>
              <span class="content-block"
                >{{ product.short_description }}
              </span>
            </div>
          </div>

          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="data-block">
              <span class="title-block">Description</span>
              <span class="content-block" v-html="product.description"> </span>
            </div>
          </div>
        </div>
      </div>

      <div class="card pb-4" v-if="product.important_information">
        <h2 class="subtitle">
          Important Information
        </h2>
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 col-12">
            <ul class="list-preview">
              <li
                v-for="(item, index) in product.important_information"
                :key="index"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card pb-4" v-if="product.meeting_points">
        <h2 class="subtitle">
          Meeting Point
        </h2>
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 col-12">
            <ul class="list-preview">
              <li v-for="(item, index) in product.meeting_points" :key="index">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card pb-4" v-if="product.additional_information.length">
        <h2 class="subtitle">
          Additional Information
        </h2>
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <ul class="list-preview">
              <li
                v-for="(item, index) in product.additional_information"
                :key="index"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div> -->
    </div>

    <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="row">
        <div class="col-xl-12 col-lg-4 col-md-4 col-sm-6 col-12">
          <!-- <div class="card">
            <h2 class="subtitle">Price</h2>
            <div class="row">
              <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="data-block">
                  <span class="title-block">Time Zone</span>
                  <span class="content-block">{{ product.time_zone }} </span>
                </div>
              </div>

              <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="data-block">
                  <span class="title-block">Currency</span>
                  <span class="content-block"
                    >{{ product.currency.code }}
                  </span>
                </div>
              </div>

              <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="data-block">
                  <span class="title-block">Price</span>
                  <span class="content-block"
                    >{{ product.currency.symbol }}
                    {{ product.pricing.amount }}
                    {{ product.currency.code }}
                  </span>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="col-xl-12 col-lg-4 col-md-4 col-sm-6 col-12">
          <div class="card">
            <h2 class="subtitle">
              What's Included
            </h2>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-expand"
            >
              <ul class="list-preview mb-3">
                <li
                  class="capitalize"
                  v-for="(item, index) in product.inclusions"
                  :key="index"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-xl-12 col-lg-4 col-md-4 col-sm-6 col-12">
          <div class="card">
            <h2 class="subtitle">
              What's not Included
            </h2>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-expand"
            >
              <ul class="list-preview mb-3">
                <li
                  class="capitalize"
                  v-for="(item, index) in product.exclusions"
                  :key="index"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-xl-12 col-lg-4 col-md-4 col-sm-6 col-12">
          <div class="card">
            <h2 class="subtitle">
              Tags
            </h2>

            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <ul class="list-preview mb-3">
                <li v-for="(item, index) in product.tags" :key="index">
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-xl-12 col-lg-8 col-md-8 col-sm-12 col-12">
          <div class="card pb-4">
            <h2 class="subtitle">
              Pictures
            </h2>

            <div class="box-drop">
              <div class="images-box  row mt-2 justify-content-between">
                <div
                  v-for="(image, index) in product.images"
                  :key="index"
                  class="image-container"
                >
                  <div class="image-wrapper-1">
                    <img v-lazy="image" alt="Preview" class="preview-image-2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { Switch, Card, DatePicker } from "element-ui";
import draggable from "vuedraggable";

export default {
  name: "ViewProduct",
  props: {
    product: {
      type: Object,
      default: () => null,
      description: "ID product"
    }
  },
  data() {
    return {
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: false,
          thStyle: { minWidth: "160px" },
          class: "text-left"
        },
        {
          key: "from",
          label: "From",
          sortable: false,
          thStyle: { minWidth: "160px" },
          class: "text-left"
        },
        {
          key: "end",
          label: "End",
          sortable: false,
          thStyle: { minWidth: "160px" },
          class: "text-left"
        },

        {
          key: "status",
          label: "Status",
          sortable: false,
          thStyle: { minWidth: "110px" },
          class: "alinmov6"
        }
      ],
      quote: "AREA"
    };
  },
  async created() {
    if (this.product) {
      this.quote = this.product.quote;
    }
  },
  methods: {
    getDateFormat(date, format) {
      return moment
        .parseZone(date)
        .utc(true)
        .format(format);
    },
    getProductTypeFormat(type) {
      if (type === "EVENTE") {
        return "Event";
      } else if (type === "PRIVATE_TRANSFER") {
        return "Private Transfer";
      } else if (type === "ATTRACTION") {
        return "Attraction";
      } else if (type === "TOUR") {
        return "Tour";
      }
    },
    getBookingType(type) {
      if (type === "AIRPORT") {
        return "Airport Transfer";
      } else if (type === "ARRIVAL") {
        return "Airport (Arrival)";
      } else if (type === "DEPARTURE") {
        return "Airport (Departure)";
      } else if (type === "STATION") {
        return "Station Transfer";
      } else if (type === "PORT") {
        return "Port Transfer";
      } else if (type === "JOURNEY") {
        return "Journey";
      }
    },
    getAvailabilityTypeFormat(type) {
      if (type === "DEFAULT") {
        return "Default";
      } else if (type === "BLACKOUT") {
        return "Blackout Dates";
      } else if (type === "UNRESTRICRED") {
        return "No Restriction";
      }
    },
    getCutOffTypeFormat(type) {
      if (type === "DEFAULT") {
        return "Default";
      } else if (type === "MINIMUM") {
        return "Minimum";
      } else if (type === "UNRESTRICRED") {
        return "No Restriction";
      }
    },
    getQuoteFormat(type) {
      if (type === "AREA") {
        return "Area";
      } else if (type === "POINTS") {
        return "From & To";
      }
    },
    getMultipleFormat(value) {
      return value ? "Yes" : "No";
    }
  },
  components: {
    [Switch.name]: Switch,
    [Card.name]: Card,
    [DatePicker.name]: DatePicker,
    draggable
  }
};
</script>
